'use client'
import React, { useState, useEffect } from 'react'
import { Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, useDisclosure } from "@nextui-org/react";
import LoginForm from '@/library/entities/core/user/components/authentication/LoginForm';
import Link from 'next/link';
import { translateIt } from '@/data/translations';
import UserCreateForm from '@/library/entities/core/user/components/authentication/UserCreateForm';


export default function LoginModal(props) {
  const {
    size = "full",
    heading = "Login",
    trigger = null,
    triggerOpen = false,
    countryId,
  } = props
  const { isOpen, onOpen, onOpenChange } = useDisclosure();

  const [renderLogin, setRenderLogin] = useState(true)

  const handleOnLoginSuccess = () => {
    onOpenChange()
  }

  const handleCreateAccountClick = () => {
    setRenderLogin(!!!renderLogin)
  }

  useEffect(() => {
    if (triggerOpen) {
      onOpen()
    }
  }, [triggerOpen])

  const renderCreateAccountLink = () => {
    return (
      <>
        {translateIt('en', 'login_dontHaveAnAccount')}
        <span onClick={handleCreateAccountClick} className="ml-2 underline cursor-pointer">
          {translateIt('en', 'login_createANewAccount')}
        </span>
      </>
    )
  }

  const renderAlreadyHaveAnAccountLink = () => {
    return (
      <>
        {translateIt('en', 'login_alreadyHaveAnAccount')}
        <span onClick={handleCreateAccountClick} className="ml-2 underline cursor-pointer">
          {translateIt('en', 'login_clickHereToLogin')}
        </span>
      </>
    )
  }

  return (
    <>
      <div onClick={onOpen}>
        {trigger && trigger}
      </div>

      <Modal isOpen={isOpen} onOpenChange={onOpenChange} size={size}>
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader className="flex flex-col gap-1">
                {heading}
              </ModalHeader>
              <ModalBody>
                {renderLogin ?
                  <LoginForm onSuccess={handleOnLoginSuccess} countryId={countryId} />
                  : <UserCreateForm onSuccess={handleOnLoginSuccess} countryId={countryId} />
                }

              </ModalBody>
              <ModalFooter className="px-8 text-xs text-muted">
                {renderLogin ? renderCreateAccountLink() : renderAlreadyHaveAnAccountLink()}
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  )
}
